import { render, staticRenderFns } from "./editFreq.vue?vue&type=template&id=ca6c405e&"
import script from "./editFreq.vue?vue&type=script&lang=js&"
export * from "./editFreq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports